import React from 'react';
import { Anchor, Wifi, Activity } from 'lucide-react';

const Logo = ({ size = 'default', className = '' }) => {
  const sizeClasses = {
    small: 'text-lg',
    default: 'text-2xl',
    large: 'text-3xl'
  };

  const iconSizes = {
    small: 'h-4 w-4',
    default: 'h-6 w-6',
    large: 'h-8 w-8'
  };

  return (
    <div className={`flex items-center space-x-2 font-bold ${sizeClasses[size]} ${className}`}>
      {/* Ana Logo Container */}
      <div className="flex items-center space-x-1">
        {/* MarIoT Text */}
        <span className="text-blue-600">Mar</span>
        <span className="text-green-600">IoT</span>
        
        {/* Boat Icon */}
        <div className="relative ml-2">
          <Anchor className={`${iconSizes[size]} text-blue-600`} />
          {/* Signal waves around the anchor */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="absolute w-3 h-3 border-2 border-blue-400 rounded-full opacity-60 animate-ping"></div>
            <div className="absolute w-2 h-2 border border-blue-500 rounded-full opacity-80"></div>
          </div>
        </div>
      </div>
      
      {/* Boat Text */}
      <span className="text-gray-700">Boat</span>
      
      {/* IoT Indicator */}
      <div className="flex items-center space-x-1 ml-1">
        <Wifi className={`${iconSizes[size]} text-green-500`} />
        <Activity className={`${iconSizes[size]} text-blue-500`} />
      </div>
    </div>
  );
};

export default Logo;
